<template>
  <div class="vote-container">
    <div v-if="config.status === 3">
      <div class="banner">
        <img :src="image.banner" alt="">
      </div>
      <div class="title-description">
        <div class="title">活动主题: {{ config.title }}</div>
        <div class="description">活动介绍: {{ config.description }}</div>
      </div>
      <transition name="van-fade">
        <div v-show="!showResult && questionType === 0" class="vote-list-text">
          <div class="vote-item" v-for="(item,index) in questionList" :key="index">
            <div class="item-title">
              {{ index*1+1 + '、' + item.title }}
              <span v-if="item.type === 1" style="color: #969799">[多选不限票]</span>
              <span v-if="item.type > 1" style="color: #969799">{{ '[多选限制投' + item.type + '票]' }}</span>
            </div>
            <div class="item-radio" v-if="item.type === 0">
              <van-radio-group
                v-model="item.val"
                checked-color="#EA2D2D"
                :disabled="disabled"
              >
                <van-radio v-for="(radioItem,radioIndex) in item.questionoptionList" :key="radioIndex" :name=radioItem.id>{{radioItem.content}}</van-radio>
              </van-radio-group>
            </div>
            <div v-if="item.type !== 0">
              <div class="item-chekBox"  v-for="(radioItem,radioIndex) in item.questionoptionList" :key="radioIndex">
                <van-checkbox-group
                  v-model="item.val"
                  checked-color="#EA2D2D"
                  :disabled="disabled"
                  :max="item.type == 1? 9999:item.type"
                >
                  <van-checkbox :name=radioItem.id shape="square" class="item-height">{{radioItem.content}}</van-checkbox>
                </van-checkbox-group>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <transition name="van-fade">
        <div v-show="showResult && questionType === 0" class="vote-list-text-result">
          <div class="item-result" v-for="(statisticItem, statisticIndex) in statisticsResult" :key="statisticIndex">
            <div class="item-title">
              {{ statisticIndex*1+1 + '、' + statisticItem.title }}
              <span v-if="statisticItem.multAns === 1" style="color: #969799">[多选]</span>
            </div>
            <div class="text-process" v-for="(statisticTextItem, statisticTextIndex) in statisticItem.lvos" :key="statisticTextIndex">
              <div class="text">{{statisticTextItem.content}}</div>
              <process-bar class="process" :percent="statisticTextItem.quPer" :number="statisticTextItem.quCount" />
            </div>
          </div>
        </div>
      </transition>
      <div class="submit-btn-container" v-if="!disabled"  :class="{ disabled: disabled }" @click="handleSubmit">
        <div class="submit-btn1" v-if="buttonType === 1 && !disabled">提交</div>
        <div class="submit-btn2" v-if="buttonType === 2 && !disabled">提交</div>
        <div class="submit-btn3" v-if="buttonType === 3 && !disabled">提交</div>
        <div class="submit-btn4" v-if="buttonType === 4 && !disabled">提交</div>
        <div class="submit-btn5" v-if="buttonType === 5 && !disabled">提交</div>
        <div class="submit-btn6" v-if="buttonType === 6 && !disabled">提交</div>
      </div>
      <div class="submit-btn-container" v-if="disabled">
        <div class="submit-btn7">提交</div>
      </div>
      <transition name="van-fade">
        <div v-show="!showResult && questionType === 1" class="vote-list-image">
          <div class="vote-item" v-for="(item,index) in questionList" :key="index">
            <div class="item-title">
              {{ index*1+1 + '、' + item.title }}
              <span v-if="item.type!==0" style="color: #969799">[多选]</span>
            </div>
            <div class="item-radio" v-if="item.type === 0">
              <van-radio-group
                v-model="item.val"
                checked-color="#EA2D2D"
              >
                <div class="option-item" v-for="(radioItem,radioIndex) in item.questionoptionList" :key="radioIndex" >
                  <div class="poster" :style="{ backgroundImage: `url(${radioItem.conImgUrl})`}"></div>
                  <div class="radio-content">
                    <van-radio :name=radioItem.id class="radio-height">{{radioItem.content}}</van-radio>
                  </div>
                </div>
              </van-radio-group>
            </div>
            <div class="item-checkbox" v-if="item.type !== 0">
              <van-checkbox-group
                v-model="item.val"
                checked-color="#EA2D2D"
                :max="item.type == 1? 9999:item.type"
              >
                <div class="option-item" v-for="(radioItem,radioIndex) in item.questionoptionList" :key="radioIndex" >
                  <div class="poster" :style="{ backgroundImage: `url(${radioItem.conImgUrl})`}"></div>
                  <div class="checkbox-content">
                    <van-checkbox :name=radioItem.id shape="square" class="checkbox-height">{{radioItem.content}}</van-checkbox>
                  </div>
                </div>
              </van-checkbox-group>
            </div>
          </div>
        </div>
      </transition>
      <transition name="van-fade">
        <div v-show="showResult && questionType === 1" class="vote-list-image-result">
          <div class="vote-item" v-for="(statisticItem, statisticIndex) in statisticsResult" :key="statisticIndex">
            <div class="item-title">
              {{ statisticIndex*1+1 + '、' + statisticItem.title }}
              <span v-if="statisticItem.multAns === 1" style="color: #969799">[多选]</span>
            </div>
            <div class="poster-text-process" v-for="(statisticImageItem, statisticImageIndex) in statisticItem.lvos" :key="statisticImageIndex">
              <div class="poster" :style="{ backgroundImage: `url(${statisticImageItem.conImgUrl})`}"></div>
              <div class="text-process">
                <div class="text">{{ statisticImageItem.content }}</div>
                <process-bar class="process" :percent="statisticImageItem.quPer" :number="statisticImageItem.quCount" />
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <div v-if="config.status === 2" class="vote-tips">
      <div class="tips-box">
        <div class="tips-icon">
          <!--<van-icon name="warning" size="60" color="#ee0924" />-->
          <img :src="require('@/assets/images/noResult2.png')" alt="" class="noResult">
        </div>
        <div class="tips-content">很抱歉，此投票已停止，不能填写</div>
      </div>
    </div>
    <div v-if="config.status === 5" class="vote-tips">
      <div class="tips-box">
        <div class="tips-icon">
          <!--<van-icon name="warning" size="60" color="#ee0924" />-->
          <img :src="require('@/assets/images/noResult1.png')" alt="" class="noResult">
        </div>
        <div class="tips-content">您已参与过</div>
      </div>
    </div>
    <div v-if="config.status === 1" class="vote-tips">
      <div class="tips-box">
        <div class="tips-icon">
          <!--<van-icon name="warning" size="60" color="#ee0924" />-->
          <img :src="require('@/assets/images/noResult3.png')" alt="" class="noResult">
        </div>
        <!--<div class="tips-title">提示</div>-->
        <div class="tips-content">该投票还未发布 请耐心等待哦</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
import ProcessBar from '@/components/ProcessBar.vue'
import {
 getbyactid, getanssta, votecommit, getWxConfig, wxGetAccessToken
} from '@/api'
import { initWx } from '@/utils/jssdk'

export default {
  name: 'index',
  components: { ProcessBar },
  data() {
    return {
      showResult: false,
      questionType: 0, // 投票类型 0-文字  1-图片
      image: {
        banner: null
      },
      config: {
        status: 0,
        title: null,
        description: null
      },
      buttonType: null, // 按钮颜色
      questionList: [], // 投票结果
      statisticsResult: [], // 投票统计结果
      disabled: false,
      openId: null
    }
  },
  created() {
    // window.title = this.config.title
    const {
      platform, phone
    } = this.$route.query
    // 1.没有手机号和平台类型就是分享打开,需要微信授权登录
    if (!platform && !phone && this.isWeixin()) {
      if (this.$route.query.redirect && this.$route.query.redirect === '1') {
        wxGetAccessToken({ code: this.$route.query.code })
          .then((res) => {
            this.openId = res.data.openid
            if (this.openId) {
              this.getbyactid()
            }
            if (this.openId === null) {
              this.getOpenId()
            }
          })
      } else {
        this.getOpenId()
      }
    } else {
      // 2.如果存在手机号平台类型就是app内打开或者h5打开
      this.getbyactid()
    }
  },
  // created() {
  //   // this.questionType = this.$route.query.type || 0
  //   const { id } = this.$route.query
  //   // const id = 11
  // },
  methods: {
    isWeixin() {
      const ua = navigator.userAgent.toLowerCase()
      // alert(/micromessenger/i.test(ua))
      if (/micromessenger/i.test(ua)) {
        return true
      }
      return false
    },
    getOpenId() {
      const appId = 'wxc81ff0696daa2a0a'
      const {
        id, platform, app, phone, preview
      } = this.$route.query
      const params = {
        id,
        platform,
        app,
        phone,
        preview
      }
      const paramsStr = JSON.stringify(params)
      const { port, hostname } = window.location
      const redirectUri = encodeURIComponent(`http://cloud.esvtek.com/auth-redirect/?params=${paramsStr}&port=${port}&hostname=${hostname}&path=/jac-direct-mall-activity-h5/vote`)
      const responseType = 'code'
      const scope = 'snsapi_base'
      window.location.replace(`https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirectUri}&response_type=${responseType}&scope=${scope}&state=STATE#wechat_redire`)
    },
    getbyactid() {
      const {
        id, phone, preview
      } = this.$route.query
      const params = {
        id,
        phone
      }
      if (this.openId) {
        params.openId = this.openId
      }
      getbyactid(params)
        .then((config) => {
          // this.posterDetail = res.data
          if (this.$route.query.preview) {
            this.disabled = true
          }
          if (preview) {
            this.config.status = 3
          } else if (config.data.remark) {
            this.config.status = 5
          } else {
            this.config.status = config.data.status
          }
          this.config.title = config.data.name
          this.buttonType = config.data.buttonType
          this.config.description = config.data.introduce
          this.image.banner = config.data.pictureUrl
          this.questionType = config.data.type
          this.questionList = config.data.voteQuestionFormList
          // this.questionList = res.data.questionList
          getWxConfig({ url: window.location.href })
            .then((res) => initWx(res.data))
            .then(() => {
              // eslint-disable-next-line no-undef
              wx.ready(() => {
                const content = {
                  title: config.data.shareTitle,
                  desc: config.data.shareText,
                  link: window.location.href,
                  imgUrl: config.data.shareImgUrl,
                  success: () => {}
                }
                // eslint-disable-next-line no-undef
                wx.updateTimelineShareData(content)
                // eslint-disable-next-line no-undef
                wx.updateAppMessageShareData(content)
              })
            })
        })
        .catch((err) => {
          this.disabled = true
          Toast(err.message)
        })
    },
    handleSubmit() {
      this.disabled = true
      const {
        platform, app, phone, address
      } = this.$route.query
      const params = {
        platform,
        app,
        phone,
        address,
        voteId: this.$route.query.id,
        // voteId: 11,
        lvacf: []
      }
      if (this.openId) {
        params.openId = this.openId
      }
      // try-catch判断是否有没选择的投票
      try {
        this.questionList.forEach((paramsItem) => {
          const lvadf = []
         // console.log(paramsItem)
          if (paramsItem.val === undefined) {
            throw new Error('请完整填写问卷')
          } else if (paramsItem.type > 1 && paramsItem.val.length !== paramsItem.type) {
            throw new Error('请勾选正确的多选项')
          } else {
            // 迷之入参 疑惑行为
            if (paramsItem.type !== 0) {
              paramsItem.val.forEach((lvadfItem) => {
                lvadf.push({ voteQuestionOptionId: lvadfItem })
              })
            } else {
              lvadf.push({ voteQuestionOptionId: paramsItem.val })
            }
            params.lvacf.push({ voteQuestionId: paramsItem.id, lvadf })
          }
        })
        votecommit(params)
          .then((res) => {
            console.log(res)
            Toast('提交成功')
            this.showResult = true
            this.getStatisticsResult()
          })
          .catch((err) => {
            Toast(err.message)
            this.disabled = false
          })
      } catch (e) {
        this.disabled = false
        if (e.message === '请完整填写问卷') {
          Toast('请完整填写问卷')
        } else if (e.message === '请勾选正确的多选项') {
          Toast('请勾选正确数量的多选项')
        } else {
          console.log(e.message)
        }
      }
    },
    // 获取投票结果
    getStatisticsResult() {
      const { id } = this.$route.query
      // const id = 11
      getanssta({ id })
        .then((res) => {
          console.log(res)
          this.statisticsResult = res.data
        })
        .catch((err) => {
          console.error(err.message)
        })
    }
  }
}
</script>

<style scoped lang="scss">
.vote-tips {
  position: fixed;
  width: 100%;
  height: 100%;
  .tips-box {
    position: absolute;
    left: 50%;
    top: 30%;
    transform: translate(-50%, -50%);
    width: 80%;
    font-size: rem(28);
    color: #666;
    text-align: center;
    .tips-title {
      line-height: rem(88);
      font-size: rem(34);
      color: #333;
      font-weight: 700;
    }
    .tips-content {
      line-height: rem(44);
    }
  }
}
.vote-container{
  background: #F5F5F5;
  margin-bottom: rem(160);
  img{
    width: 100%;
    display: block;
  }
  .title-description{
    background: #FFFFFF;
    padding: rem(32) rem(24);
    margin-bottom: rem(16);
    .title{
      color: #333333;
      font-size: rem(32);
      font-weight: bold;
    }
    .description{
      margin-top: rem(16);
      color: #666666;
      font-size: rem(28);
    }
  }
  .vote-list-text{
    background-color: #FFFFFF;
    padding: rem(20) rem(0);
    .vote-item{
      padding-left: rem(32);
      padding-right: rem(32);
      margin-bottom: rem(24);
      .item-title{
        //height: rem(104);
        color: #333333;
        font-size: rem(32);
        line-height: rem(60);
        font-weight: 400;
        margin-bottom: rem(20);
      }
      .item-radio{
        //min-height: rem(104);
        //line-height: rem(104);
        margin-bottom: rem(20);
        display: flex;
        ::v-deep{
          .van-radio{
            //height: rem(104);
            align-items: flex-start;
            margin-bottom: rem(20);
          }
          .van-radio__label{
            font-size: rem(32);
            word-break: break-word;
          }
        }
      }
      .item-chekBox{
        //min-height: rem(104);
        //line-height: rem(104);
        margin-bottom: rem(20);
        display: flex;
        .van-checkbox{
          align-items: flex-start;
          //margin-bottom: rem(40);
          //height: rem(104);
        }
        .item-height{
          //height: 0.7rem;
        }
        ::v-deep{
          .van-checkbox__label{
            font-size: rem(32);
            word-break: break-word;
          }
        }
      }
    }
  }
  .vote-list-text-result{
    background-color: #FFFFFF;
    padding: rem(20) 0;
    .item-result{
      padding-left: rem(32);
      padding-right: rem(32);
      margin-bottom: rem(24);
      .item-title{
        //height: rem(104);
        color: #333333;
        font-size: rem(32);
        line-height: rem(48);
        font-weight: 400;
      }
      .text-process{
        padding-top: rem(12);
        margin-bottom: rem(32);
        .text{
          color: #333333;
          font-size: rem(32);
          margin-bottom: rem(16);
          word-break: break-all;
        }
        .process{
          margin-bottom: rem(12);
        }
      }
    }
  }
  .submit-btn-container{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: rem(32);
    background-color: #FFFFFF;
    z-index: 200;
    .submit-btn1{
      height: rem(96);
      border-radius: rem(8);
      text-align: center;
      font-size: rem(32);
      line-height: rem(96);
      color: #000000;
      border: groove;
    }
    .submit-btn2{
      height: rem(96);
      border-radius: rem(8);
      text-align: center;
      font-size: rem(32);
      line-height: rem(96);
      background: linear-gradient(90deg, #1989fa 0%, #1989fa 100%);
      color: #FFFFFF;
    }
    .submit-btn3{
      height: rem(96);
      border-radius: rem(8);
      text-align: center;
      font-size: rem(32);
      line-height: rem(96);
      background: linear-gradient(90deg, #07c160 0%, #07c160 100%);
      color: #FFFFFF;
    }
    .submit-btn4{
      height: rem(96);
      border-radius: rem(8);
      text-align: center;
      font-size: rem(32);
      line-height: rem(96);
      background: linear-gradient(90deg, #bdbdbd 0%, #aaa  100%);
      color: #FFFFFF;
    }
    .submit-btn5{
      height: rem(96);
      border-radius: rem(8);
      text-align: center;
      font-size: rem(32);
      line-height: rem(96);
      background: linear-gradient(90deg, #ffd01e  0%, #ffd01e   100%);
      color: #FFFFFF;
    }
    .submit-btn6{
      height: rem(96);
      border-radius: rem(8);
      text-align: center;
      font-size: rem(32);
      line-height: rem(96);
      background: linear-gradient(90deg, #FF5D5D 0%, #D82626 100%);
      color: #FFFFFF;
    }
    .submit-btn7{
      height: rem(96);
      border-radius: rem(8);
      text-align: center;
      font-size: rem(32);
      line-height: rem(96);
      background: linear-gradient(90deg, #E0E0E0 0%, #CCCCCC 100%);
      color: #FFFFFF;
    }
  }
  .vote-list-image{
    background-color: #FFFFFF;
    padding: rem(40) 0;
    .vote-item{
      padding-left: rem(32);
      padding-right: rem(32);
      margin-bottom: rem(24);
      .item-title{
        //height: rem(104);
        color: #333333;
        font-size: rem(32);
        line-height: rem(40);
        font-weight: 400;
        margin-bottom: rem(20);
      }
      .item-radio{
        .van-radio-group{
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          .option-item{
            width: rem(327);
            border: 1px solid #DDDDDD;
            margin-bottom: rem(32);
            .poster{
              width: rem(327);
              height: rem(184);
              background: #EEEEEE;
              background-repeat: round;
            }
            .radio-content{
              //height: rem(104);
              display: flex;
              align-items: center;
              padding-left: rem(16);
              .radio-height {
                //height: 0.7rem;
                line-height: rem(30);
              }
              ::v-deep{
                .van-radio__label{
                  font-size: rem(32);
                  word-break: break-all;
                  padding: rem(10) 0;
                }
              }
            }
          }
        }
      }
      .item-checkbox{
        .van-checkbox-group{
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          .option-item{
            width: rem(327);
            border: 1px solid #DDDDDD;
            margin-bottom: rem(32);
            .poster{
              width: rem(327);
              height: rem(184);
              background: #EEEEEE;
              background-repeat: round;
            }
            .checkbox-content{
              //height: rem(104);
              display: flex;
              align-items: center;
              padding-left: rem(16);
              .checkbox-height{
                //height: 0.7rem;
              }
              ::v-deep{
                .van-checkbox__label{
                  font-size: rem(32);
                  word-break: break-all;
                  padding: rem(10) 0;
                }
              }
            }
          }
        }
      }
    }
  }
  .vote-list-image-result{
    background-color: #FFFFFF;
    .vote-item{
      padding-left: rem(32);
      padding-right: rem(32);
      margin-bottom: rem(24);
      .item-title{
        //height: rem(104);
        color: #333333;
        font-size: rem(32);
        line-height: rem(40);
        font-weight: 400;
      }
      .poster-text-process{
        display: flex;
        justify-content: space-between;
        height: rem(161);
        align-items: center;
        .poster{
          width: rem(200);
          height: rem(113);
          background: #EEEEEE;
          margin-right: rem(24);
          background-repeat: round;
        }
        .text-process{
          flex-grow: 1;
          .text{
            line-height: rem(40);
            color: #333333;
            font-size: rem(32);
            margin-bottom: rem(16);
            margin-top: rem(12);
            word-break: break-all;
          }
        }
      }
    }
  }
  .submit-btn-container.disabled{
    .submit-btn{
      background: linear-gradient(90deg, #E0E0E0 0%, #CCCCCC 100%);
    }
  }
}
</style>
